export const FORCE_VISIBILITY_OPTIONS = [
  { label: 'Visible', value: 'visible_forced' },
  { label: 'Hidden', value: 'hidden_forced' },
];
